import { render, staticRenderFns } from "./Obligacion.vue?vue&type=template&id=2aca99a1&"
import script from "./Obligacion.vue?vue&type=script&lang=js&"
export * from "./Obligacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports